import {
  findRegionsForSalesOrgs,
  nonRestrictedRegionNames,
  RegionName,
} from '../components/regions-menu/regions-menu';
import { getUserSalesOrgs } from '../libs/auth';
import { useLocalStorage } from './use-local-storage';

const defaultRegions = [''];

function useRegions() {
  const [regions, setRegionsInStorage] = useLocalStorage(
    'regions',
    defaultRegions
  );

  const setRegions = (newRegions: RegionName[], setByAuth = false) => {
    const orgs = getUserSalesOrgs();
    const assignedRegions = findRegionsForSalesOrgs(orgs);

    // no restrictions, carry on as usual
    if (
      assignedRegions.length === nonRestrictedRegionNames.length &&
      setByAuth
    ) {
      return;
    }

    if (assignedRegions.length > 0 && setByAuth) {
      return setRegionsInStorage(newRegions);
    }

    setRegionsInStorage(newRegions);
  };

  return [regions, setRegions];
}

export { useRegions };
